import { Stack, Spinner, SpinnerSize, AnimationClassNames, CommandBar, ICommandBarItemProps } from '@fluentui/react';
import { useCallback, useEffect, useMemo } from 'react';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import shallow from 'zustand/shallow';
import { useStore } from '../../../../../context/store';
import { useGridUndo } from '../../../_grid/useGridActionHistory';

export const Toolbar = ({
    // currentView,
    // viewHasFilterChanges,
    // setViewHasFilterChanges,
    // views,
    // setCurrentViewId,
    // setOpenPanel,
    // currentViewFilters,
    setUseLegacyAllocation,
}: {
    // currentView: GridView;
    // viewHasFilterChanges: boolean;
    // setViewHasFilterChanges: (changes: boolean) => void;
    // views: GridView[];
    // setCurrentViewId: (id: string) => void;
    // setOpenPanel: (state: boolean) => void;
    // currentViewFilters: GridViewFilters;
    setUseLegacyAllocation: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
    const addWarningNotification = useStore(store => store.addWarningNotification, shallow);

    const { redo, redoStackCount, undo, undoStackCount, loading } = useGridUndo();
    const handleUndo = useCallback(async () => {
        if (undoStackCount) {
            return undo();
        } else {
            addWarningNotification('Nothing to undo');
        }
    }, [addWarningNotification, undo, undoStackCount]);
    const handleRedo = useCallback(async () => {
        if (redoStackCount) {
            return redo();
        } else {
            addWarningNotification('Nothing to redo');
        }
    }, [addWarningNotification, redo, redoStackCount]);
    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (e.ctrlKey && !loading) {
                const key = e.key.toLowerCase();
                if (key === 'z') {
                    handleUndo();
                } else if (key === 'y') {
                    handleRedo();
                }
            }
        };
        window.addEventListener('keydown', handler);
        return () => {
            window.removeEventListener('keydown', handler);
        };
    }, [loading, handleUndo, handleRedo]);

    const leftItems = useMemo(
        (): ICommandBarItemProps[] => [
            {
                onClick: () => setUseLegacyAllocation(true),
                key: 'switch-to-classic',
                text: `Switch to classic`,
            },
        ],
        [setUseLegacyAllocation],
    );

    const rightItems = useMemo(
        (): ICommandBarItemProps[] => [
            {
                iconProps: { iconName: 'Undo' },
                key: 'undo',
                text: `Undo (${undoStackCount})`,
                disabled: !undoStackCount || loading,
            },
            {
                iconProps: { iconName: 'Redo' },
                key: 'redo',
                text: `Redo (${redoStackCount})`,
                disabled: !redoStackCount || loading,
            },
        ],
        [loading, redoStackCount, undoStackCount],
    );

    return (
        <Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: 5, padding: 5 }}>
            <Stack>
                <CommandBar items={leftItems} />
            </Stack>
            <Stack horizontal>
                <Loader />
                <CommandBar items={rightItems} />
            </Stack>
        </Stack>
    );
};

const Loader = () => {
    const fetching = useIsFetching();
    const mutating = useIsMutating();
    const loading = fetching !== 0 || mutating !== 0;
    return <Spinner size={SpinnerSize.large} className={loading ? AnimationClassNames.fadeIn200 : AnimationClassNames.fadeOut200} />;
};
